import React from 'react'
import { NavLink } from 'react-router-dom'
import MegaMenu from './MegaMenu';

function MainNav() {
    return (
        <>
            <li className='nav-item dropdown mega-menu'>
                <p className="dropdown-toggle d-flex align-items-center p-0 m-0 py-2  p-2 rounded border" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="bi bi-list h5 me-2  d-flex align-items-center"></i>
                    <span>دسته بندی محصولات</span>
                </p>
                <MegaMenu />
            </li>
            <li className="nav-item">
                <NavLink className="nav-link fs13 active " aria-current="page" to='/'>صفحه اصلی</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link fs13" to='/store'>فروشگاه</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link fs13" to='https://www.titandisti.com/' target="_blank">وبلاگ</NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link fs13" to='/contact'>تماس با ما</NavLink>
            </li>
        </>
    )
}

export default MainNav